import GloLayout from 'lowcode/common/GloLayout';
import css from './index.module.scss';
import ClientComp from './ClientComp';

export default function Content({ id, data, initIndex = 0, isEditStatus = false }: any) {
    return (
        <GloLayout id={id} className={`${css['eco-flash-sale-box']}`}>
            <ClientComp data={data} isEditStatus={isEditStatus} />
        </GloLayout>
    );
}
